import { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { getSuccessStory } from "../redux/action";
import {
  SEO, PageLayout
} from "../components";
import { workIcon, freeIcon, interviewIcon, fastTrackInstruct, playIcon, ledIcon, suitcaseIcon, writeIcon, contactIcon } from "../images";
import TechCourseHeader from "../components/techExperience/tech-course-header";
import TechCourseInfo from "../components/techExperience/tech-course-info";
import TechCourseInfoBenefit from "../components/techExperience/tech-course-info-benefit";
import TechCoursePlayer from "../components/techExperience/tech-course-player";
import TechCourseTestimonial from "../components/techExperience/tech-course-testimonial";
import TechCourseTools from "../components/techExperience/tech-course-tools";
import StudentSuccess from "../components/home/student-success-stories";
import TechCourseUpdate from "../components/techExperience/tech-course-update";
import TechPayments from "../components/payments/tech-payments";
import TechInstructorCarousel from "../components/techExperience/tech-instructor-carousel";
import TechFaq from "../components/techExperience/tech-faq";
import CourseCarousel from "../components/course/course-custom-Carousel";
import StartYourJourney from "../components/home/start-your-journey";
import EnrolNow from "../components/modals/enrol-now";
import DownloadCta from "../components/modals/download-cta";

function TechExperienceCoursePage() {
  // Animated titles for the course
  const animatedTitles = useMemo(() => [
    "Business Analyst",
    "Product Owner",
    "Product Manager"
  ], []);  const [titleIndex, setTitleIndex] = useState(0);
  const [displayedTitle, setDisplayedTitle] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let typingSpeed = 70;
    let deletingSpeed = 40;
    let pauseAfterTyping = 1200;
    let pauseAfterDeleting = 400;
    let timeout;
    const fullTitle = animatedTitles[titleIndex];

    if (!isDeleting && displayedTitle.length < fullTitle.length) {
      timeout = setTimeout(() => {
        setDisplayedTitle(fullTitle.slice(0, displayedTitle.length + 1));
      }, typingSpeed);
    } else if (!isDeleting && displayedTitle.length === fullTitle.length) {
      timeout = setTimeout(() => {
        setIsDeleting(true);
      }, pauseAfterTyping);
    } else if (isDeleting && displayedTitle.length > 0) {
      timeout = setTimeout(() => {
        setDisplayedTitle(fullTitle.slice(0, displayedTitle.length - 1));
      }, deletingSpeed);
    } else if (isDeleting && displayedTitle.length === 0) {
      timeout = setTimeout(() => {
        setIsDeleting(false);
        setTitleIndex((prev) => (prev + 1) % animatedTitles.length);
      }, pauseAfterDeleting);
    }
    return () => clearTimeout(timeout);
  }, [displayedTitle, isDeleting, titleIndex, animatedTitles]);
  // Hardcoded data for the tech experience page
  const hardcodedCourse = {
    id: 999,
    title:  "Business Analyst Work Experience",
    slug: "tech-experience",
    courseDescription: "Build a work portfolio that lands you the job. This is your first step to showing hiring managers and recruiters that you are not just ready - you are already doing the work.",
    videoLink2: "https://vimeo.com/877951686/e6409b5720?share=copy",
    videoLink1: "https://vimeo.com/807291099/fc16df41f4?share=copy&turnstile=0.3X5AoDvCWI8Irk5SP3mpWNueNm5DGJ8-v6L9xzycRaTRMymY5tslYHRIDK_EnYNMDivzkw7p0Dq_jcquBHLxFMh8tce3AbHGmf8fsDvfE3sY4Jo9yxshaYQMhE6OWMp3bZ81H-6kBqDSzTYyl0O0qU-M234wEjGvwrD0XGkSh1C8P5YvICI3_wYuLXqTG32bIcCVo0V-D2pLtDfOz4bx77Mwdwu0-p2AIPOmbQ77l6-jhnzmYt4LbiWqGLsWHqzR3weoDDSmXiyQkkNUjDhyOAQBA1qqzPBI0wXKnR3twdGXRJ4CFLrzKHZRiowdqK0b6zmUm9LrULbSRtnOFKjiFsqXF8PGopQ73ZpsIT66rmasy3jsQMTSBwX5AC7gbrKAmoa9F9ULDId04aWl6D23GDLNM2RhS2xl01P8k1uzifTqWbNNkZntg2BVeFL7fjaWZUqAK9chRWx8lzPY2GSg0fviAH7yUMhwIt3WgM7EIHHYb7ync2uK6Nzo0RLUQekRnvfbW8rRlwRDGa40_ER5xQE2emmSP97bUTOHrNS9g96CRVssLOtA27p3ViyWvRW4U2uOKdy6hJpMbObCR-NjPmNDtCKFwk0EogKa6kSqyn8OwE4uPWZvMyRO90b3RzKYwnXLNh6fuX9CSF_6Xtq2K9Ucbfy5DbrYIACtRT22XSwmMvntW0Hi2V5ia5-emYJ0udz4z_JKkxVpb7Rm9bLO0ZCwx2BQATPtL1-u5ZE0JoN6RGmlXj6ugksOEMkEypwdiJN8Wd8hB7kUQ6BTp-1HwlD2DWBSN5hXDOGVXddEdpqULXVB6CFUDxnUqG8gMtJoEcd5_9u36VLTQ0_QvW6r7Q.8tBYu06q9qD8FnaOizTHOw.525cf25fc4daa44636f6b47e825847513cd56d64275395b830086d5ee2f04c62",
    videoLink3: "https://youtu.be/NHJA6ZNkQaU",
    videoLink4: "https://youtu.be/7hwqU2taEMI",
    cards: [
      {
        id: 1,
        icons: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720012649/beginner_2911e6ec92.png", name: "Icon1" },
        card_title: "Week 1  ",
        card_sub_title: "Project Brief & Orientation",
        card_content: "Kickstart with full project brief and team onboarding."
      },
      {
        id: 2,
        icons: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720012649/expert_d9b25d1b59.png", name: "Icon2" },
        card_title: "Week 2 -3 ",
        card_sub_title: "Immersion & Vision",
        card_content: "Define the project vision with clear scope Alignment."
      },
      {
        id: 3,
        icons: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1748485338/write_c92effb7e9.svg", name: "Icon3" },
        card_title: "Week 4-5",
        card_sub_title: "Conceive & Design",
        card_content: "Translate detailed requirements into process flows & prototypes. "
      },
      {
        id: 4,
        icons: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720012648/job_ready_1ab70d0641.png", name: "Icon4" },
        card_title: "Week 6 - 8 ",
        card_sub_title: "Build & Test",
        card_content: "Begin development and validate with test cases."
      },
      {
        id: 5,
        icons: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720012649/network_89692bc2b3.png", name: "Icon5" },
        card_title: "Week 9",
        card_sub_title: "UAT & Feedback",
        card_content: "Conduct UAT with Stakeholders and collect feedback."
      },
      {
        id: 6,
        icons: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720012648/hands_on_443d9113cd.png", name: "Icon6" },
        card_title: "Week 10",
        card_sub_title: " Team Demos & Handovers",
        card_content: "Showcase final product and project handovers."
      } 
    ],    text_and_cards: [
      {
        cardFirstColumn: [
          { id: 1, icon: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720016636/led_live_instructor_94cf00e3c9.png" }, name: "Project", title: "Build a Job-Winning Portfolio", text: "" }
        ],
        secondColumnOne: [
          { id: 2, icon: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720016636/hands_on_project_ex_9bfb1899d6.png" }, name: "Mentor", title: "Master the tools and techniques", text: "" }
        ],
        secondColumnTwo: [
          { id: 3, icon: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720016636/personalised_eeffbdb29f.png" }, name: "Certificate", title: "Gain resume-ready experience", text: "" }
        ],
        thirdColumn: [
          { id: 4, icon: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720016636/inerview_preparation_bbd49c67d2.png" }, name: "Career", title: "Facilitate like a true leader", text: "" }
        ],
        fourthColumn: [
          { id: 5, icon: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1720016636/on_the_job_15c2b42dd5.png" }, name: "Network", title: "Present with executive presence ", text: "" }
        ],
        fifthColumn: [
          { id: 6, icon: { url: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1748485525/group_users_168fc33205.svg" }, name: "Portfolio", title: "Get credible work reference", text: "" }
        ],
        
        topPill: " Jira Walkthrough Video Training",
        sectionTitle: "What you get",
        description: "You will deliver projects recruiters actually care about. Gain hands-on with Jira, Confluence, Miro, Figma and more. Add credible, collaborative work to your professional story. Lead stand-ups, workshops and stakeholder meetings with ease. Wow stakeholders with polished reports and confident demos and receive a verifiable reference to unlock your next role.",
      }
    ],
    course_analyses: [
      {
        topPill: "Top Rated",
        heading: "Why Join?",
        subHeading: "Career Growth",
        description: "Boost your tech career with real experience."
      }
    ],
    courseSchedules: [
      {
        id: 1,
        week: 1,
        weekDescription: "Getting Started",
        hoursToComplete: "4 hours",
        title: "Introduction to Tech",
        description: "Kickoff and orientation.",
        skills: [{ id: 1, title: "Collaboration" }],
        modules: [{ id: 1, title: "Module 1: Basics" }]
      },
      {
        id: 2,
        week: 2,
        weekDescription: "Project Collaboration",
        hoursToComplete: "4 hours",
        title: "Project Work",
        description: "Work on a real project.",
        skills: [{ id: 2, title: "Project Management" }],
        modules: [{ id: 2, title: "Module 2: Project" }]
      }
    ],
    regionPrice: { "US & Canada": 500, "Europe - Africa": 300 },
    course_instructors: [
      {
        id: 1,
        name: "Michael Akpan",
        photo: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1718361091/micheal_a57b775d30.jpg",
        qualification: [{ id: 1, qualification: "Lead Coach" }, { id: 2, qualification: "CBAP" }, { id: 3, qualification: "PSPO" }, { id: 4, qualification: "PSM" }, { id: 5, qualification: "SAFe" }, { id: 6, qualification: "CSPO" }],
        socialNetwork: [],
        companies: [],
        description: `Michael is a seasoned product leader, consultant, and senior business analyst with over a decade of experience. He empowers tech industry aspirants through exceptional teaching and commitment, helping them attain their goals.

Michael is a data-driven digital strategist with technical depth and intuitive user experience skills. His customer-focused approach creates digital products that enhance customer experience while delivering stakeholder solutions.

He has worked with global brands like TELUS, ABBOTT, ROGERS, OLG, BARCLAYS, RBC, LAURENTIAN BANK, ABB OPTICAL, COCA-COLA across industries including Telecommunications, Financial Services, Retail, Education, E-commerce, and Real Estate.

Michael is an associate fellow of the UK Higher Education Academy and looks forward to preparing you for your business analyst role.`
      },
      {
        id: 2,
        name: "Stella Odumosu",
        photo: "https://res.cloudinary.com/dm04lhyfi/image/upload/v1718036770/stella_instructor_46ef537d9c.jpg",
        qualification: [{ id: 2, qualification: "Mentor" }, { id: 3, qualification: "CSM" }, { id: 4, qualification: "SAFe" }, { id: 5, qualification: "CSPO" }],
        socialNetwork: [],
        companies: [],
        description: `Stella Odumosu is a multifaceted professional with expertise in product management, product ownership, and Scrum mastery. With over 5 years in insurance at companies like Allstate, GoHealth, and Integrity Marketing, Stella is passionate about coaching and mentoring.

She believes success is attainable for anyone willing to put in the effort. Stella has guided individuals to secure roles from business analyst to product ownership, Scrum master, and tech sales consulting.

Stella's commitment to helping others succeed sets her apart as a dedicated professional nurturing talent and promoting growth. With her experience and desire to see others thrive, Stella continues to make a lasting impact in the industry and beyond.`
      }
    ],
    successStories: [
      {
        id: 1,
        title: "Success Story",
        testimonials: [
          {
            id: 1,
            full_name: "Alice",
            position: "Graduate",
            story: "Got a job after the bootcamp!",
            photo: { url: "https://placehold.co/80x80", name: "Alice" },
            videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
          },
          {
            id: 2,
            full_name: "Bob",
            position: "Graduate",
            story: "Got a job after the bootcamp!",
            photo: { url: "https://placehold.co/80x80", name: "Bob" },
            videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
          },
          {
            id: 3,
            full_name: "Charlie",
            position: "Graduate",
            story: "Got a job after the bootcamp!",
            photo: { url: "https://placehold.co/80x80", name: "Charlie" },
            videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
          },
          {
            id: 4,
            full_name: "Diana",
            position: "Graduate",
            story: "Got a job after the bootcamp!",
            photo: { url: "https://placehold.co/80x80", name: "Diana" },
            videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ"
          }
        ]
      }
    ],
    info: [{ label: "Duration", value: "2 weeks", id: 1 }],
    benefits: [{ text: "Real-world projects", id: 1 }],
    analysis: [{ label: "Success Rate", value: "95%", id: 1 }],
    testimonials: [{ name: "Alice", text: "Great experience!", id: 1 }],    tools: [{ name: "Jira", id: 1 }],
    update: [{ date: "2025-06-01", update: "Kickoff", id: 1 }],
    carousel: [{ id: 1, title: "Other Course" }],
    faq: [
      { 
        id: 1, 
        question: "Who is this program for?", 
        answer: "This practicum is ideal for aspiring or Business Analysts, Project Managers, and Product Managers looking to gain hands-on experience, build their portfolio, and confidently apply for real-world roles."
      },
      {
        id: 2,
        question: "Do I need prior experience to join?",
        answer: "No prior work experience is required. However, participants should have completed foundational training in Business Analysis, Project Management, or Product Management. If you're unsure, we can guide you to the right learning path before joining."
      },
      {
        id: 3,
        question: "What tools will I learn to use?",
        answer: "You'll get hands-on experience with leading industry tools including Jira, Confluence, Miro, Figma, Zoom, and Google Workspace—just like in real tech teams."
      },
      {
        id: 4,
        question: "What kind of projects will I work on?",
        answer: "You'll work on real-life client projects that mirror industry scenarios—such as building internal platforms, customer journey mapping, feature design, UAT testing, CRM workflows, and more. These projects are designed with recruiters and hiring managers in mind."
      },
      {
        id: 5,
        question: "Will I work in a team?",
        answer: "Yes. You'll collaborate in agile teams made up of fellow practicum participants, guided by experienced mentors. Same scenarios as how real tech teams operate to help you build soft skills like facilitation, communication, and collaboration."
      },
      {
        id: 6,
        question: "How is this different from a typical course?",
        answer: "This isn't a course—it's a practicum. Instead of lectures, you'll be doing the work: leading meetings, documenting requirements, designing workflows, building user stories, and delivering demos—just like on the job."
      },
      {
        id: 7,
        question: "What will I walk away with at the end?",
        answer: "You'll complete the program with a portfolio-ready project, hands-on tool experience, a verifiable reference you can leverage for your next job search, and the confidence to ace interviews and perform on the job."
      },
      {
        id: 8,
        question: "Is this a paid opportunity?",
        answer: "This is a training-based experience designed to help you build work readiness. It's unpaid but delivers high value in terms of mentorship, networking, and career-ready skills. Many past participants land interviews or roles within weeks of completing the practicum."
      }
    ],
  };
  const [isEnrolOpen, setIsEnrolOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showBanner, setShow] = useState(false);
  const paymentsRef = useRef(null);  const [regionNames] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("US & Canada");
  const dispatch = useDispatch();

  // Fetch success stories for the component
  useEffect(() => {
    dispatch(getSuccessStory());
  }, [dispatch]);

  const scrollToPayments = () => {
    if (paymentsRef.current) {
      const yOffset = -100;
      const element = paymentsRef.current;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <>
      <SEO
        url="/tech-experience"
        openGraphType="website"
        schemaType="website"
        title={hardcodedCourse.title}
        description="A hands-on bootcamp to gain real-world tech experience."
      />
      <PageLayout>
        <TechCourseHeader
          regions={['US & Canada', 'Europe - Africa']}
          defaultRegion={selectedRegion}
          course={hardcodedCourse}
          allCourses={{}}
          bannerTile={hardcodedCourse.title}
          bannerMessage={hardcodedCourse.courseDescription}
          setIsModalOpen={setIsModalOpen}
          scrollToPayments={scrollToPayments}
          selectedRegion={selectedRegion}
          onRegionChange={setSelectedRegion}
        />        <TechCourseInfo cards={hardcodedCourse.cards} />        <TechCourseInfoBenefit setIsEnrolOpen={setIsEnrolOpen} course={hardcodedCourse} scrollToPayments={scrollToPayments} />
        
        <div className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            <h2 className="text-2xl font-semibold mb-10 text-center">Program Sneak Peeks</h2>
            <div className="flex flex-col items-center space-y-12 max-w-2xl mx-auto">
              {hardcodedCourse.videoLink1 && <TechCoursePlayer course={hardcodedCourse.videoLink1} title="Sneak peek 1 - Daily Stand-up with Devs" />}
              {hardcodedCourse.videoLink2 && <TechCoursePlayer course={hardcodedCourse.videoLink2} title="Sneak peek 2 - Requirement Elicitation Session" />}
              {hardcodedCourse.videoLink3 && <TechCoursePlayer course={hardcodedCourse.videoLink3} title="Sneak peek 3 -  Design Review Session" />}
              {hardcodedCourse.videoLink4 && <TechCoursePlayer course={hardcodedCourse.videoLink4} title="Sneak peek 4 - Project Presentation Session " />}
            </div>
          </div>
        </div>
        
        <TechCourseUpdate
          course={hardcodedCourse}
          allCourses={{}}
          scrollToPayments={scrollToPayments}
          setIsEnrolOpen={setIsEnrolOpen}
          setIsModalOpen={setIsModalOpen}
          selectedRegion={selectedRegion}
          onRegionChange={setSelectedRegion}
        />
        <TechCourseTestimonial course={hardcodedCourse.title} />
        <TechCourseTools course={hardcodedCourse.title} />        {hardcodedCourse.regionPrice && (
          <TechPayments
            ref={paymentsRef}
            setIsEnrolOpen={setIsEnrolOpen}
            isEnrolOpen={isEnrolOpen}
            showBanner={showBanner}
            courseBanner={{ title: "Special Offer", description: "Limited Time Only" }}
            setShowBanner={setShow}
            selectedRegion={selectedRegion}
          />
        )}
       
        <StudentSuccess course="tech-experience" title="Student Success Stories" />
        {hardcodedCourse.course_instructors && <TechInstructorCarousel items={hardcodedCourse.course_instructors} />}
        <TechFaq course={hardcodedCourse.faq} />
        <CourseCarousel exempt={hardcodedCourse.id} />
        <StartYourJourney />
      </PageLayout>
      {isEnrolOpen && <EnrolNow Close={() => setIsEnrolOpen(false)} course={hardcodedCourse} regionNames={regionNames} setIsEnrolOpen={setIsEnrolOpen} allCourses={{}} />}
      {isModalOpen && <DownloadCta onClose={() => setIsModalOpen(false)} courses={hardcodedCourse} />}
    </>
  );
}

export default TechExperienceCoursePage;
